import React, { useState } from 'react';
import { Menu, Search, Bell, User, LogOut, Settings as SettingsIcon, ArrowLeft } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { logoutUser } from '../utils/api';

const Header = ({ onMenuClick }) => {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const { user, logout, userSites, originalUser, isImpersonating, switchBackToOriginal } = useAuth();
  const navigate = useNavigate();

  //console.log('user', user);  

  return (
    <>
      {/* Impersonation Banner */}
      {isImpersonating && originalUser && (
        <div className="bg-yellow-50 border-b border-yellow-200 px-6 py-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="flex-shrink-0">
                <User className="h-5 w-5 text-yellow-600" />
              </div>
              <div>
                <p className="text-sm font-medium text-yellow-800">
                  You are logged in as <span className="font-bold">{user?.name || user?.fname || 'User'}</span>
                </p>
                <p className="text-xs text-yellow-600">
                  Original user: {originalUser.name || `${originalUser.fname || ''} ${originalUser.lname || ''}`.trim() || 'Admin'}
                </p>
              </div>
            </div>
            <button
              onClick={() => {
                switchBackToOriginal();
                navigate('/admin/dashboard', { replace: true });
              }}
              className="flex items-center space-x-2 px-4 py-2 bg-yellow-600 text-white text-sm font-medium rounded-md hover:bg-yellow-700 transition-colors"
            >
              <ArrowLeft className="h-4 w-4" />
              <span>Switch Back to {originalUser.name || `${originalUser.fname || ''} ${originalUser.lname || ''}`.trim() || 'Admin'}</span>
            </button>
          </div>
        </div>
      )}
      
      <header className="bg-white shadow-sm border-b border-gray-200 px-6 py-4">
        <div className="flex items-center justify-between">
          
          {user?.role === 'admin' && (
            <h4 className="text-2xl font-bold">Super Admin Dashboard</h4>
          )}

        {/* Left side - Mobile menu button and search */}
        <div className="flex items-center space-x-4">
          <button
            onClick={onMenuClick}
            className="lg:hidden p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100"
          >
            <Menu className="h-6 w-6" />
          </button>
          
          {/* Search 
          <div className="relative hidden md:block">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Search className="h-5 w-5 text-gray-400" />
            </div>
            <input
              type="text"
              placeholder="Search..."
              className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
            />
          </div>*/}
        </div>

        {/* Right side - Notifications and user menu */}
        <div className="flex items-center space-x-4">
          {/* Notifications 
          <button className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 relative">
            <Bell className="h-6 w-6" />
            <span className="absolute top-1 right-1 block h-2 w-2 rounded-full bg-red-400"></span>
          </button>*/}

          {/* User menu */}
          <div className="relative">
            <button
              onClick={() => setShowUserMenu(!showUserMenu)}
              className="flex items-center space-x-3 p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100"
            >
              <div className="w-8 h-8 bg-primary-600 rounded-full flex items-center justify-center">
                <span className="text-white text-sm font-medium">{user?.name?.charAt(0) || 'U'}</span>
              </div>
              <span className="hidden md:block text-sm font-medium">{user?.name || 'User'}</span>
            </button>

            {/* Dropdown menu */}
            {showUserMenu && (
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50 border border-gray-200">
                <div className="px-4 py-2 border-b border-gray-100">
                  <p className="text-sm font-medium text-gray-900">{user?.name || 'User'}</p>
                  <p className="text-sm text-gray-500">{user?.email || 'user@example.com'}</p>
                  <p className="text-sm text-gray-500">{user?.role || 'user@example.com'}</p>
                  {user?.site_name && (
                    <p className="text-sm text-blue-600 font-medium mt-1">{user?.site_name}</p>
                  )}
                </div>
                
                {/**<a
                  href="#profile"
                  className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  <User className="mr-3 h-4 w-4" />
                  Profile
                </a>*/}
                
                {/**<a
                  href="#settings"
                  className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  <SettingsIcon className="mr-3 h-4 w-4" />
                  Settings
                </a>*/}
                
                <div className="border-t border-gray-100">
                  <button
                    onClick={async () => {
                      try {
                        // Call API logout
                        await logoutUser();
                      } catch (error) {
                        console.error('Logout API error:', error);
                      } finally {
                        // Always logout locally regardless of API response
                        logout();
                        navigate('/login');
                        setShowUserMenu(false);
                      }
                    }}
                    className="w-full text-left flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    <LogOut className="mr-3 h-4 w-4" />
                    Sign out
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
    </>
  );
};

export default Header;
